"use client";
import React from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { AccordionComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";


const faqs = [
  {
    question: "What is a Personal Loan?",
    answer:
      "A Personal Loan is an unsecured loan offered to salaried and self-employed individuals for different purposes. It's approved instantly and disbursed quickly with minimal paperwork and without security.",
  },
  {
    question: "How to get an instant Personal Loan of Rs 5 Lakh?",
  },
  {
    question:
      "What is the minimum income required for a Rs 5 Lakh Personal Loan?",
  },
  {
    question: "How much salary is needed for a Rs 2 Lakh Personal Loan?",
  },
  {
    question: "How can I calculate my Personal Loan EMI?",
  },
];

const FAQSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        textAlign={"center"}
      >
        {isMobile ? "FAQs" : "Frequently asked questions"}
      </Typography>
      {faqs?.map((faq, index) => (
        <AccordionComponent
          key={index}
          defaultExpanded={index === 0}
          title={faq.question}
          headerProps={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "16px" },
          }}
          detailsProps={{ sx: { backgroundColor: "white" } }}
        >
          {faq.answer && (
            <Typography
              color="#212529"
              sx={{ fontWeight: 400, fontSize: { xs: "12px", md: "16px" } }}
            >
              {faq.answer}
            </Typography>
          )}
        </AccordionComponent>
      ))}
      <Grid textAlign="center" mt={3} xs={12}>
        <Button variant="contained" sx={{ backgroundColor: WEB_COLORS.darkTeal, color:"#E9FFE6" }} >
          View All
        </Button>
      </Grid>
    </Box>
  );
};

export default FAQSection;
